import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameStatus from "../model/GameStatus";
import SaveModel from "../model/SaveModel";


export default class StartGameCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     */
    constructor(dispatcher, saveModel, gameModel) {
        super(dispatcher);

        this.execute = function() {
            const saveGame = saveModel.getSaveGame();
            if (saveGame) {
                gameModel.restore(saveGame);
            }
            if (gameModel.status == GameStatus.END) {
                this.gotoScreen(SkinKeys.END_SCREEN);
            } else {
                this.gotoScreen(SkinKeys.GAME_SCREEN);
            }
        };
    };

}